/** The legacy shape is evidence, not a current Better quote. Unknown stays null. */
export function readHostInsurancePolicySummary(snapshot: unknown): {
  packageName: string | null;
  stateCode: string | null;
  insuredValue: number | null;
} | null {
  if (!snapshot || typeof snapshot !== "object" || Array.isArray(snapshot)) return null;
  const policy = snapshot as Record<string, unknown>;
  const text = (value: unknown) => typeof value === "string" && value.trim() ? value.trim() : null;
  const amount = (value: unknown) =>
    typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : null;
  const historical = policy.rule_version === "legacy-driveshare-host-better-v2"
    && typeof policy.provider === "string" && policy.provider.toLowerCase() === "better";
  return {
    packageName: text(policy.package_name) ?? (historical ? text(policy.operational_package) : null),
    stateCode: text(policy.state_code),
    insuredValue: amount(policy.insured_value) ?? (historical ? amount(policy.valuation) : null),
  };
}
